export class DiameterFilter {
    minMaxDiameter
    filterType = 'diametro'
    constructor(minMaxDiameter) {
        this.minMaxDiameter = minMaxDiameter
    }

    apply(products) {
        return products.filter(product => {
            let diameter = 0;
            if (product.Diametro.toLowerCase().indexOf('x') > -1) {
                const aux = product.Diametro.split('x')
                diameter = aux[0]
            } else {
                diameter = product.Diametro
            }
            return (parseFloat(diameter) >= this.minMaxDiameter[0] && parseFloat(diameter) <= this.minMaxDiameter[1])
        })
    }
}